var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"ml-4"},[_c('li',[_c('b',[_vm._v("Flow length")]),_vm._v(": "+_vm._s(_vm.alarm.$flowLengthReadable))]),(_vm.alarm.$flowDataAggWindowReadable)?_c('li',[_c('b',[_vm._v("Period:")]),_vm._v(" "+_vm._s(_vm.alarm.$flowDataAggWindowReadable)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }